import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CertificadoCompleto, CertificadoState } from '../types';
import {
  atualizarCertificadoPorItem,
  buscarCertificadoPorItem,
  buscarCertificadoPorMessage,
  gerarCertificadoPdfServerSide,
  renderCertificadoPdf,
} from './actions';

const initialState: CertificadoState = {
  certificado: null,
  isLoading: false,
  error: null,
  renderPdfResultUrl: null,
  renderPdfFileSizeMb: null,
  isRenderPdfLoading: false,
  renderPdfError: null,
};

const certificadoSlice = createSlice({
  name: 'certificado',
  initialState,
  reducers: {
    clearCertificado: (state) => {
      state.certificado = null;
      state.error = null;
      state.renderPdfResultUrl = null;
      state.renderPdfFileSizeMb = null;
      state.isRenderPdfLoading = false;
      state.renderPdfError = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(buscarCertificadoPorItem.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        buscarCertificadoPorItem.fulfilled,
        (state, action: PayloadAction<CertificadoCompleto>) => {
          state.isLoading = false;
          state.certificado = action.payload;
        },
      )
      .addCase(buscarCertificadoPorItem.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      .addCase(
        atualizarCertificadoPorItem.fulfilled,
        (state, action: PayloadAction<CertificadoCompleto>) => {
          // A recarga sai sem `await` depois do download: se a pessoa já navegou (`clearCertificado`
          // ou outro certificado carregado), a resposta atrasada não pode trocar a tela.
          if (state.certificado?.id === action.payload.id) {
            state.certificado = action.payload;
          }
        },
      )

      .addCase(buscarCertificadoPorMessage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        buscarCertificadoPorMessage.fulfilled,
        (state, action: PayloadAction<CertificadoCompleto>) => {
          state.isLoading = false;
          state.certificado = action.payload;
        },
      )
      .addCase(buscarCertificadoPorMessage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(renderCertificadoPdf.pending, (state) => {
        state.isRenderPdfLoading = true;
        state.renderPdfError = null;
        state.renderPdfResultUrl = null;
        state.renderPdfFileSizeMb = null;
      })
      .addCase(renderCertificadoPdf.fulfilled, (state, action) => {
        state.isRenderPdfLoading = false;
        state.renderPdfError = null;
        state.renderPdfResultUrl = action.payload.resultUrl;
        state.renderPdfFileSizeMb = action.payload.fileSizeMb;
      })
      .addCase(renderCertificadoPdf.rejected, (state, action) => {
        state.isRenderPdfLoading = false;
        state.renderPdfError = action.payload || 'Falha ao gerar PDF';
      })

      .addCase(gerarCertificadoPdfServerSide.pending, (state) => {
        state.isRenderPdfLoading = true;
        state.renderPdfError = null;
        state.renderPdfResultUrl = null;
      })
      .addCase(gerarCertificadoPdfServerSide.fulfilled, (state, action) => {
        state.isRenderPdfLoading = false;
        state.renderPdfError = null;
        state.renderPdfResultUrl = action.payload.pdfUrl ?? null;
      })
      .addCase(gerarCertificadoPdfServerSide.rejected, (state, action) => {
        state.isRenderPdfLoading = false;
        state.renderPdfError = action.payload || 'Falha ao gerar PDF do certificado';
      });
  },
});

export const { clearCertificado } = certificadoSlice.actions;
export default certificadoSlice.reducer;
